module.exports = "<nav-bar-view></nav-bar-view>\r\n\r\n<div class=\"wrapper\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n<app-footer-home></app-footer-home>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/app.component.html
// module id = ./Frontend/src/app/app.component.html
// module chunks = main